import { render, staticRenderFns } from "./SRTrendingTimelineItemWrapper.vue?vue&type=template&id=88bbced8"
import script from "./SRTrendingTimelineItemWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./SRTrendingTimelineItemWrapper.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SRTrendingTimelineItemWrapper.vue?vue&type=style&index=0&id=88bbced8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports